import {
  AreaChart, Area, LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer,
} from "recharts";
import { formatCompact } from "@/lib/format";

const tooltipStyle = {
  backgroundColor: "hsl(var(--card))",
  border: "1px solid hsl(var(--border))",
  borderRadius: 12,
  fontSize: 12,
  fontFamily: "'IBM Plex Mono', monospace",
  boxShadow: "0 8px 30px -8px rgba(17, 24, 39, 0.15)",
  color: "hsl(var(--foreground))",
};

export default function GrowthCharts({ growth }) {
  if (!growth || growth.length === 0) {
    return (
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-10">
        <div className="card-flat p-8 text-center text-sm text-muted-foreground">
          Growth history is not available for this channel yet.
        </div>
      </section>
    );
  }

  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-10">
      <div className="flex items-baseline justify-between mb-4">
        <h2 className="text-2xl font-extrabold tracking-tight">Growth</h2>
        <div className="overline">Based on recent uploads</div>
      </div>
      <div data-testid="growth-charts" className="grid md:grid-cols-2 gap-4">
        <div className="card-flat p-6">
          <div className="overline mb-4">Cumulative views</div>
          <div className="h-64">
            <ResponsiveContainer>
              <AreaChart data={growth}>
                <defs>
                  <linearGradient id="gViews" x1="0" y1="0" x2="0" y2="1">
                    <stop offset="0%" stopColor="#FF6B00" stopOpacity={0.35} />
                    <stop offset="100%" stopColor="#FF6B00" stopOpacity={0} />
                  </linearGradient>
                </defs>
                <CartesianGrid strokeDasharray="3 3" stroke="hsl(var(--border))" />
                <XAxis dataKey="date" tick={{ fill: "hsl(var(--muted-foreground))", fontSize: 10 }} />
                <YAxis tick={{ fill: "hsl(var(--muted-foreground))", fontSize: 10 }} tickFormatter={formatCompact} />
                <Tooltip contentStyle={tooltipStyle} formatter={(v) => formatCompact(v)} />
                <Area type="monotone" dataKey="cumulative_views" stroke="#FF6B00" fill="url(#gViews)" strokeWidth={2.5} />
              </AreaChart>
            </ResponsiveContainer>
          </div>
        </div>
        <div className="card-flat p-6">
          <div className="overline mb-4">Videos published</div>
          <div className="h-64">
            <ResponsiveContainer>
              <LineChart data={growth}>
                <CartesianGrid strokeDasharray="3 3" stroke="hsl(var(--border))" />
                <XAxis dataKey="date" tick={{ fill: "hsl(var(--muted-foreground))", fontSize: 10 }} />
                <YAxis tick={{ fill: "hsl(var(--muted-foreground))", fontSize: 10 }} />
                <Tooltip contentStyle={tooltipStyle} />
                <Line type="monotone" dataKey="videos" stroke="#3B82F6" strokeWidth={2.5} dot={false} />
              </LineChart>
            </ResponsiveContainer>
          </div>
        </div>
        <div className="card-flat p-6 md:col-span-2">
          <div className="overline mb-4">Views per video (timeline)</div>
          <div className="h-64">
            <ResponsiveContainer>
              <LineChart data={growth}>
                <CartesianGrid strokeDasharray="3 3" stroke="hsl(var(--border))" />
                <XAxis dataKey="date" tick={{ fill: "hsl(var(--muted-foreground))", fontSize: 10 }} />
                <YAxis tick={{ fill: "hsl(var(--muted-foreground))", fontSize: 10 }} tickFormatter={formatCompact} />
                <Tooltip contentStyle={tooltipStyle} formatter={(v) => formatCompact(v)} />
                <Line type="monotone" dataKey="views" stroke="#10B981" strokeWidth={2.5} dot={{ r: 3, fill: "#10B981" }} />
              </LineChart>
            </ResponsiveContainer>
          </div>
        </div>
      </div>
    </section>
  );
}
